import { render, staticRenderFns } from "./AsociarServicioDescarga.vue?vue&type=template&id=3d0da9aa&"
import script from "./AsociarServicioDescarga.vue?vue&type=script&lang=ts&"
export * from "./AsociarServicioDescarga.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports